// you can import modules from the theme lib or even from
// NPM packages if they support it…
import ExampleComponent1 from "./components/ExampleComponent1";

// you can also require modules if they support it…
const home = require('./components/homepage');
const app = require('./vue/app')

// Initialise our components on jQuery.ready…
jQuery(function ($) {
    home.init();
});